import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import tweenState from 'kw-react-tween-state';
import assign from 'object-assign';
import ExecutionEnvironment from 'exenv';
import decorators from './decorators';

const addEvent = function(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent(`on${type}`, eventHandle);
  } else {
    elem[`on${type}`] = eventHandle;
  }
};

const removeEvent = function(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent(`on${type}`, eventHandle);
  } else {
    elem[`on${type}`] = null;
  }
};

/* eslint-disable react/prefer-es6-class, react/prop-types, sort-keys */
const Carousel = createReactClass({
  displayName: 'Carousel',

  mixins: [tweenState.Mixin],

  propTypes: {
    afterSlide: PropTypes.func,
    autoplay: PropTypes.bool,
    autoplayInterval: PropTypes.number,
    beforeSlide: PropTypes.func,
    cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
    cellSpacing: PropTypes.number,
    data: PropTypes.func,
    decorators: PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func,
        position: PropTypes.oneOf([
          'BottomCenter',
          'BottomLeft',
          'BottomRight',
          'BottomRightZoom',
          'CenterCenter',
          'CenterLeft',
          'CenterRight',
          'TopCenter',
          'TopLeft',
          'TopRight',
        ]),
        style: PropTypes.object,
      }),
    ),
    displayButtons: PropTypes.array,
    dragging: PropTypes.bool,
    easing: PropTypes.string,
    edgeEasing: PropTypes.string,
    frameOverflow: PropTypes.string,
    framePadding: PropTypes.string,
    imageWidth: PropTypes.string,
    imageMaxWidth: PropTypes.string,
    initialSlideHeight: PropTypes.number,
    initialSlideWidth: PropTypes.number,
    openPhotoSwipe: PropTypes.func,
    s3BasePath: PropTypes.string,
    slideIndex: PropTypes.number,
    slidesToScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),
    slidesToShow: PropTypes.number,
    slideWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    speed: PropTypes.number,
    swiping: PropTypes.bool,
    vertical: PropTypes.bool,
    width: PropTypes.string,
    wrapAround: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      afterSlide() {},
      autoplay: false,
      autoplayInterval: 3000,
      beforeSlide() {},
      cellAlign: 'left',
      cellSpacing: 0,
      data() {},
      decorators,
      displayButtons: ['PreviousButton', 'NextButton', 'ZoomButton', 'SlideIndicators'],
      dragging: true,
      easing: 'easeOutCirc',
      edgeEasing: 'easeOutElastic',
      frameOverflow: 'hidden',
      framePadding: '0px',
      imageWidth: '100%',
      openPhotoSwipe() {},
      slideIndex: 0,
      slidesToScroll: 1,
      slidesToShow: 1,
      slideWidth: 1,
      speed: 500,
      swiping: true,
      vertical: false,
      width: '100%',
      wrapAround: false,
    };
  },

  getInitialState() {
    return {
      currentSlide: this.props.slideIndex,
      dragging: false,
      frameWidth: 0,
      left: 0,
      slideCount: 0,
      slidesToScroll: this.props.slidesToScroll,
      slideWidth: 0,
      top: 0,
    };
  },

  componentWillMount() {
    this.setInitialDimensions();
  },

  componentDidMount() {
    this.setDimensions();
    this.bindEvents();
    this.setExternalData();
    if (this.props.autoplay) {
      this.startAutoplay();
    }
    // fix to the issue with carousel on mobile home page and product detail
    // based on https://github.com/FormidableLabs/nuka-carousel/issues/265#issuecomment-403350905
    setTimeout(() => {
      this.setDimensions();
    }, 0);
  },

  componentWillReceiveProps(nextProps) {
    this.setState({ slideCount: nextProps.children.length });
    this.setDimensions(nextProps);
    if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
      this.goToSlide(nextProps.slideIndex);
    }
    if (this.props.autoplay !== nextProps.autoplay) {
      if (nextProps.autoplay) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }
  },

  componentWillUnmount() {
    this.unbindEvents();
    this.stopAutoplay();
  },

  render() {
    const self = this;
    const { decorators, displayButtons } = this.props;

    const activeDecorators = decorators.filter(decorator => {
      const { displayName } = decorator.component;
      return displayButtons.includes(displayName);
    });

    const children =
      React.Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;

    return (
      <div
        className={['slider', this.props.className || ''].join(' ')}
        ref="slider"
        style={assign(this.getSliderStyles(), this.props.style || {})}
      >
        <div
          className="slider-frame"
          onClick={this.handleClick}
          ref="frame"
          style={this.getFrameStyles()}
          {...this.getMouseEvents()}
          {...this.getTouchEvents()}
        >
          <ul className="slider-list" ref="list" style={this.getListStyles()}>
            {children}
          </ul>
        </div>
        {activeDecorators
          ? activeDecorators.map((Decorator, index) => {
              return (
                <div
                  className={`slider-decorator-${index}`}
                  key={`slider-decorator-${index}`}
                  style={assign(self.getDecoratorStyles(Decorator.position), Decorator.style || {})}
                >
                  <Decorator.component
                    cellSpacing={self.props.cellSpacing}
                    currentSlide={self.state.currentSlide}
                    frameWidth={self.state.frameWidth}
                    goToSlide={self.goToSlide}
                    nextSlide={self.nextSlide}
                    openPhotoSwipe={self.props.openPhotoSwipe}
                    previousSlide={self.previousSlide}
                    s3BasePath={self.props.s3BasePath}
                    slideCount={self.state.slideCount}
                    slidesToScroll={self.state.slidesToScroll}
                    slidesToShow={self.props.slidesToShow}
                    slideWidth={self.state.slideWidth}
                    wrapAround={self.props.wrapAround}
                  />
                </div>
              );
            })
          : null}
        <style type="text/css" dangerouslySetInnerHTML={{ __html: self.getStyleTagStyles() }} />
      </div>
    );
  },

  // Touch Events

  touchObject: {},

  getTouchEvents() {
    const self = this;

    if (self.props.swiping === false) {
      return null;
    }

    return {
      onTouchCancel(e) {
        self.handleSwipe(e);
      },
      onTouchEnd(e) {
        self.handleSwipe(e);
        self.handleMouseOut();
      },
      onTouchMove(e) {
        const direction = self.swipeDirection(
          self.touchObject.startX,
          e.touches[0].pageX,
          self.touchObject.startY,
          e.touches[0].pageY,
        );

        if (direction !== 0) {
          // Commented out due to a change in how event listeners are handled in Chrome.
          // Because this event is treated as passive the preventDefault is ignored and throws a
          // warning in Chrome v56 and above.
          // e.preventDefault();
        }

        const length = self.props.vertical
          ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2)))
          : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));

        self.touchObject = {
          direction,
          endX: e.touches[0].pageX,
          endY: e.touches[0].pageY,
          length,
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0,
        });
      },
      onTouchStart(e) {
        self.touchObject = {
          startX: e.touches[0].pageX,
          startY: e.touches[0].pageY,
        };
        self.handleMouseOver();
      },
    };
  },

  clickSafe: true,

  getMouseEvents() {
    const self = this;

    if (this.props.dragging === false) {
      return null;
    }

    return {
      onMouseOver() {
        self.handleMouseOver();
      },
      onMouseOut() {
        self.handleMouseOut();
      },
      onMouseDown(e) {
        self.touchObject = {
          startX: e.clientX,
          startY: e.clientY,
        };

        self.setState({ dragging: true });
      },
      onMouseMove(e) {
        if (!self.state.dragging) {
          return;
        }

        const direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);

        if (direction !== 0) {
          e.preventDefault();
        }

        const length = self.props.vertical
          ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2)))
          : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));

        self.touchObject = {
          direction,
          endX: e.clientX,
          endY: e.clientY,
          length,
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0,
        });
      },
      onMouseUp(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
      onMouseLeave(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
    };
  },

  handleMouseOver() {
    if (this.props.autoplay) {
      this.autoplayPaused = true;
      this.stopAutoplay();
    }
  },

  handleMouseOut() {
    if (this.props.autoplay && this.autoplayPaused) {
      this.startAutoplay();
      this.autoplayPaused = null;
    }
  },

  handleClick(e) {
    if (this.clickSafe === true) {
      e.preventDefault();
      e.stopPropagation();

      if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
      }
    }
  },

  handleSwipe(e) {
    if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
      this.clickSafe = true;
    } else {
      this.clickSafe = false;
    }

    let { slidesToShow } = this.props;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }

    if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
      if (this.touchObject.direction === 1) {
        if (
          this.state.currentSlide >= React.Children.count(this.props.children) - slidesToShow &&
          !this.props.wrapAround
        ) {
          this.animateSlide(tweenState.easingTypes[this.props.edgeEasing]);
        } else {
          this.nextSlide();
        }
      } else if (this.touchObject.direction === -1) {
        if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
          this.animateSlide(tweenState.easingTypes[this.props.edgeEasing]);
        } else {
          this.previousSlide();
        }
      }
    } else {
      this.goToSlide(this.state.currentSlide);
    }

    this.touchObject = {};

    this.setState({ dragging: false });
  },

  swipeDirection(x1, x2, y1, y2) {
    let swipeAngle;
    const xDist = x1 - x2;
    const yDist = y1 - y2;
    const r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round((r * 180) / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return 1;
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return 1;
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return -1;
    }
    if (this.props.vertical === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 1;
      }
      return -1;
    }
    return 0;
  },

  autoplayIterator() {
    if (this.props.wrapAround) {
      return this.nextSlide();
    }
    if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
      this.nextSlide();
    } else {
      this.stopAutoplay();
    }
  },

  startAutoplay() {
    this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
  },

  resetAutoplay() {
    if (this.props.autoplay && !this.autoplayPaused) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  },

  stopAutoplay() {
    this.autoplayID && clearInterval(this.autoplayID);
  },

  // Action Methods

  goToSlide(index) {
    const self = this;
    if (index >= React.Children.count(this.props.children) || index < 0) {
      if (!this.props.wrapAround) {
        return;
      }
      if (index >= React.Children.count(this.props.children)) {
        this.props.beforeSlide(this.state.currentSlide, 0);
        return this.setState({ currentSlide: 0 }, () => {
          self.animateSlide(null, null, self.getTargetLeft(null, index), () => {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(0);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      }
      const endSlide = React.Children.count(this.props.children) - this.state.slidesToScroll;
      this.props.beforeSlide(this.state.currentSlide, endSlide);
      return this.setState({ currentSlide: endSlide }, () => {
        self.animateSlide(null, null, self.getTargetLeft(null, index), () => {
          self.animateSlide(null, 0.01);
          self.props.afterSlide(endSlide);
          self.resetAutoplay();
          self.setExternalData();
        });
      });
    }

    this.props.beforeSlide(this.state.currentSlide, index);

    this.setState({ currentSlide: index }, function() {
      self.animateSlide();
      this.props.afterSlide(index);
      self.resetAutoplay();
      self.setExternalData();
    });
  },

  nextSlide() {
    const childrenCount = React.Children.count(this.props.children);
    let { slidesToShow } = this.props;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }
    if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
    } else {
      if (this.props.slideWidth !== 1) {
        return this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
      }
      this.goToSlide(Math.min(this.state.currentSlide + this.state.slidesToScroll, childrenCount - slidesToShow));
    }
  },

  previousSlide() {
    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
    } else {
      this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
    }
  },

  // Animation

  animateSlide(easing, duration, endValue, callback) {
    this.tweenState(this.props.vertical ? 'top' : 'left', {
      duration: duration || this.props.speed,
      easing: easing || tweenState.easingTypes[this.props.easing],
      endValue: endValue || this.getTargetLeft(),
      onEnd: callback || null,
    });
  },

  getTargetLeft(touchOffset, slide) {
    let offset;
    const target = slide || this.state.currentSlide;
    switch (this.props.cellAlign) {
      case 'left': {
        offset = 0;
        offset -= this.props.cellSpacing * target;
        break;
      }
      case 'center': {
        offset = (this.state.frameWidth - this.state.slideWidth) / 2;
        offset -= this.props.cellSpacing * target;
        break;
      }
      case 'right': {
        offset = this.state.frameWidth - this.state.slideWidth;
        offset -= this.props.cellSpacing * target;
        break;
      }
    }

    let left = this.state.slideWidth * target;

    const lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

    if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
      left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
      offset = 0;
      offset -= this.props.cellSpacing * (this.state.slideCount - 1);
    }

    offset -= touchOffset || 0;

    return (left - offset) * -1;
  },

  // Bootstrapping

  bindEvents() {
    const self = this;
    if (ExecutionEnvironment.canUseDOM) {
      addEvent(window, 'resize', self.onResize);
      addEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  onResize() {
    this.setDimensions();
  },

  onReadyStateChange() {
    this.setDimensions();
  },

  unbindEvents() {
    const self = this;
    if (ExecutionEnvironment.canUseDOM) {
      removeEvent(window, 'resize', self.onResize);
      removeEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  formatChildren(children) {
    const self = this;
    const positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
    return React.Children.map(children, (child, index) => {
      return (
        <li className="slider-slide" key={`slider-slide-${index}`} style={self.getSlideStyles(index, positionValue)}>
          {child}
        </li>
      );
    });
  },

  setInitialDimensions() {
    const self = this;

    const slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
    const slideHeight = this.props.initialSlideHeight ? this.props.initialSlideHeight * this.props.slidesToShow : 0;

    const frameHeight = slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);

    this.setState(
      {
        frameWidth: this.props.vertical ? frameHeight : '100%',
        slideCount: React.Children.count(this.props.children),
        slideHeight,
        slideWidth,
      },
      () => {
        self.setLeft();
        self.setExternalData();
      },
    );
  },

  setDimensions(props) {
    props = props || this.props;

    const self = this;
    let slideHeight;
    let slidesToScroll;
    let slideWidth;

    slidesToScroll = props.slidesToScroll;
    const { frame } = this.refs;
    const firstSlide = frame.childNodes[0].childNodes[0];
    if (firstSlide) {
      firstSlide.style.height = 'auto';
      slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
    } else {
      slideHeight = 100;
    }

    if (typeof props.slideWidth !== 'number') {
      slideWidth = parseInt(props.slideWidth);
    } else if (props.vertical) {
      slideWidth = (slideHeight / props.slidesToShow) * props.slideWidth;
    } else {
      slideWidth = (frame.offsetWidth / props.slidesToShow) * props.slideWidth;
    }

    if (!props.vertical) {
      slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
    }

    const frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
    const frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

    if (props.slidesToScroll === 'auto') {
      slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
    }

    this.setState(
      {
        frameWidth,
        left: props.vertical ? 0 : this.getTargetLeft(),
        slideHeight,
        slidesToScroll,
        slideWidth,
        top: props.vertical ? this.getTargetLeft() : 0,
      },
      () => {
        self.setLeft();
      },
    );
  },

  setLeft() {
    this.setState({
      left: this.props.vertical ? 0 : this.getTargetLeft(),
      top: this.props.vertical ? this.getTargetLeft() : 0,
    });
  },

  // Data

  setExternalData() {
    if (this.props.data) {
      this.props.data();
    }
  },

  // Styles

  getListStyles() {
    const listWidth = this.state.slideWidth * React.Children.count(this.props.children);
    const spacingOffset = this.props.cellSpacing * React.Children.count(this.props.children);
    const transform = `translate3d(${this.getTweeningValue('left')}px, ${this.getTweeningValue('top')}px, 0)`;

    return {
      boxSizing: 'border-box',
      cursor: this.state.dragging === true ? 'pointer' : 'inherit',
      display: 'block',
      height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
      margin: this.props.vertical
        ? `${(this.props.cellSpacing / 2) * -1}px 0px`
        : `0px ${(this.props.cellSpacing / 2) * -1}px`,
      MozBoxSizing: 'border-box',
      msTransform: `translate(${this.getTweeningValue('left')}px, ${this.getTweeningValue('top')}px)`,
      padding: 0,
      position: 'relative',
      transform,
      WebkitTransform: transform,
      width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
    };
  },

  getFrameStyles() {
    return {
      boxSizing: 'border-box',
      display: 'block',
      height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
      margin: this.props.framePadding,
      MozBoxSizing: 'border-box',
      msTransform: 'translate(0, 0)',
      overflow: this.props.frameOverflow,
      padding: 0,
      position: 'relative',
      transform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
    };
  },

  getSlideStyles(index, positionValue) {
    const targetPosition = this.getSlideTargetPosition(index, positionValue);
    return {
      boxSizing: 'border-box',
      display: this.props.vertical ? 'block' : 'inline-block',
      height: 'auto',
      left: this.props.vertical ? 0 : targetPosition,
      listStyleType: 'none',
      marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
      marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
      MozBoxSizing: 'border-box',
      position: 'absolute',
      top: this.props.vertical ? targetPosition : 0,
      verticalAlign: 'top',
      width: this.props.vertical ? '100%' : this.state.slideWidth,
    };
  },

  getSlideTargetPosition(index, positionValue) {
    const slidesToShow = this.state.frameWidth / this.state.slideWidth;
    const targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
    const end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;

    if (this.props.wrapAround) {
      const slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
      if (this.state.slideCount - slidesBefore <= index) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
      }

      let slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);

      if (this.state.slideWidth !== 1) {
        slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
      }

      if (index <= slidesAfter - 1) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
      }
    }

    return targetPosition;
  },

  getSliderStyles() {
    return {
      boxSizing: 'border-box',
      display: 'block',
      height: 'auto',
      MozBoxSizing: 'border-box',
      position: 'relative',
      visibility: this.state.slideWidth ? 'visible' : 'hidden',
      width: this.props.width,
    };
  },

  getStyleTagStyles() {
    return `.slider-slide > img {
      display: block;
      margin: 0 auto 0 auto;
      width: ${this.props.imageWidth};
      ${this.props.imageMaxWidth ? `max-width: ${this.props.imageMaxWidth};` : null};
    }`;
  },

  getDecoratorStyles(position) {
    switch (position) {
      case 'TopLeft':
        return {
          left: 0,
          position: 'absolute',
          top: 0,
        };
      case 'TopCenter':
        return {
          left: '50%',
          msTransform: 'translateX(-50%)',
          position: 'absolute',
          top: 0,
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
        };
      case 'TopRight':
        return {
          position: 'absolute',
          right: 0,
          top: 0,
        };
      case 'CenterLeft':
        return {
          left: 0,
          msTransform: 'translateY(-50%)',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          WebkitTransform: 'translateY(-50%)',
        };
      case 'CenterCenter':
        return {
          left: '50%',
          msTransform: 'translate(-50%, -50%)',
          position: 'absolute',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          WebkitTransform: 'translate(-50%, -50%)',
        };
      case 'CenterRight':
        return {
          msTransform: 'translateY(-50%)',
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          WebkitTransform: 'translateY(-50%)',
        };
      case 'BottomLeft':
        return {
          bottom: 0,
          left: 0,
          position: 'absolute',
        };
      case 'BottomCenter':
        return {
          bottom: 0,
          left: '50%',
          msTransform: 'translateX(-50%)',
          position: 'absolute',
          transform: 'translateX(-50%)',
          WebkitTransform: 'translateX(-50%)',
        };
      case 'BottomRight':
        return {
          bottom: 0,
          position: 'absolute',
          right: 0,
        };
      case 'BottomRightZoom':
        return {
          bottom: 20,
          position: 'absolute',
          right: 10,
        };
      default:
        return {
          left: 0,
          position: 'absolute',
          top: 0,
        };
    }
  },
});

Carousel.ControllerMixin = {
  getInitialState() {
    return { carousels: {} };
  },
  setCarouselData(carousel) {
    const data = this.state.carousels;
    data[carousel] = this.refs[carousel];
    this.setState({ carousels: data });
  },
};

export default Carousel;
